import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Loading from '../../../../shared/loading';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import { create } from '../../../../services/wire/edit-attachment-services';

export default class AddAttachmentModal extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    onAttachmentAdded: PropTypes.func.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
      attachment: undefined,
      title: undefined,
      error: undefined,
    };
  }

  handleAttachmentFileChange(e) {
    this.setState({ attachment: e.target.files[0] });
  }

  handleTitleChange(e) {
    this.setState({ title: e.target.value });
  }

  present() {
    this.setState({ show: true });
  }

  dismiss() {
    this.$input.val('');
    this.setState({
      show: false,
      attachment: undefined,
      title: undefined,
      error: undefined,
    });
  }

  save() {
    if (!this.state.attachment) {
      this.setState({ error: 'Please select a file' });
      return;
    }

    this.loading.start();
    create(this.props.wireId, this.state.attachment, this.state.title)
      .then(result => {
        this.props.onAttachmentAdded(result.data);
        this.dismiss();
      })
      .catch(e => {
        defaultOnErrorHandler(e, 'Error uploading the attachment');
        this.setState({ error: 'Invalid File Format' });
      })
      .finally(() => this.loading.stop());
  }

  render() {
    return (
      <Modal
        centered="true"
        dialogAs="article"
        show={this.state.show}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title as="h4">Add attachment</Modal.Title>
        </Modal.Header>
        <Modal.Body as="section">
          <Loading ref={c => (this.loading = c)}>
            <form>
              <div className="form-group grid gap-4">
                {!!this.state.error && (
                  <span className="text-red-700 font-extrabold text-sm">{this.state.error}</span>
                )}
                <label htmlFor="add-attachment-select-file">
                  <span className="font-black">
                    * Select file (File types accepted: PDF and Excel)
                  </span>
                  <input
                    id="add-attachment-select-file"
                    accept=".pdf,.xls,.xlsx"
                    type="file"
                    ref={el => (this.$input = $(el))}
                    onChange={e => this.handleAttachmentFileChange(e)}
                  />
                </label>
                <label htmlFor="add-attachment-title">
                  Title
                  <input
                    type="text"
                    className="form-control"
                    id="add-attachment-title"
                    placeholder="Optional and Maximum of 60 characters."
                    maxLength="60"
                    onChange={e => this.handleTitleChange(e)}
                  />
                </label>
              </div>
            </form>
          </Loading>
        </Modal.Body>
        <Modal.Footer as="footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => this.dismiss()}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => this.save()}
          >
            Upload
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
